import { SessionModuleState } from ".";

export const SET_CURRENT_CLUSTER_INSTANCE_ID = (
  state: SessionModuleState,
  id?: string
) => {
  state.currentClusterInstanceId = id;
};

export const SET_SEARCH_PREFIX = (
  state: SessionModuleState,
  prefix?: string
) => {
  state.searchPrefix = prefix;
};
